module.exports = __webpack_public_path__ + "img/rannyfx.293fb83b.png";